import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {HeaderTitleAction, headerTitleActionTypes} from '../actions/header-title';

export interface HeaderTitleState {
  header: {title: string , icon: string};
}

const initialState: HeaderTitleState = {
  header:  null
};

export function headerTitleReducer(state: HeaderTitleState = initialState, action: Action): HeaderTitleState {
  switch (action.type) {
    case headerTitleActionTypes.UPDATE:
      return handleUpdateAction(state, action);
    case headerTitleActionTypes.CLEAR:
      return handleClearAction(state);
    default:
      return state;
  }
}

function handleUpdateAction(state: HeaderTitleState, action: HeaderTitleAction): HeaderTitleState {
  const newState = _.clone(state);
  newState.header = action.payload ;
  return newState;
}
function handleClearAction(state: HeaderTitleState): HeaderTitleState {
  const newState = initialState;
  return newState;
}

export const headerTitleSelectors = {
  header: (state: HeaderTitleState) => _.get(state, 'header', {})
};
